import Progress from "./Configurator/Progress.es6";
import Overlay  from "./Configurator/Overlay.es6";
import Preview  from "./Configurator/Preview.es6";
import Bottom   from "./Configurator/Bottom.es6";
import mode     from "./Configurator/Mode.es6";

export default class {
    constructor(Design) {
        // Load Classes
        new App.Interface.Storage('design-configurator', this);
        // Constants
        this.PURCHASE_LEVEL_LOW     = 0;
        this.PURCHASE_LEVEL_MEDIUM  = 1;
        this.PURCHASE_LEVEL_HIGH    = 2;

        // Define params
        this.Design = Design;
        this.mode   = this.mode.DESIGN_HASH;
        this.allowImageUpdaload = App.Variable('allowImageUpdate') || false;

        // Expose
        window.Configurator = this;

        this.Progress = new Progress(this);
        this.run();
    }

    async run() {
        this.Progress.restore();
        await this.preload();
        await this.update();
        this.Progress.main.start;
    }

    // Services
    get Observer()  { return this._observer || (this._observer = new App.Entities.Observer(this)) }

    // Config
    get mode()  { return mode }

    // Getters
    get container() { return document.getElementById('design-configurator-overlay') }
    get Overlay()   { return this._overlay || (this._overlay = new Overlay(this)) }
    get Preview()   { return this._preview || (this._preview = new Preview(this)) }
    get btype()     { return App.Variable('btype') }
    get Bottom()    { return this._bottom || (this._bottom = new Bottom(this)) }
    // Setters
    set mode(mode)          { this.mode.current = mode } // shortcut
    set content(content)    { this.container.innerHTML = content }

    // Getters & Setters
    get id () { return this._id || App.Variable('id') }
    set id(id) { this._id = id }

    async preload() {
        await this.Overlay.preload();
    }

    start(name) {
        // Reset step to not get stuck in this one again
        if (this.Progress.isRemovePreviousStep()) this.Progress.current.remove();
        const step = this.Progress.get(name);
        if (step) {
            if (step.main && this.Progress.current) {
                name = this.Progress.current.name;
                this.Progress.current.start;
            } else {
                step.start;
            }
            this.Overlay.select(name);
        } else {
            throw new Error('Step ' + name + ' does not exist');
        }
        return this;
    }

    color(identifier) {
        return this.colors[identifier];
    }

    get colors() {
        return App.Variable('colors');
    }

    async normalize() {
        if (App.Interface.Utilities.isMobile()) await App.Components.Popup.hide();
    }

    save(values) {
        this.Progress.current.save(values);
        return this;
    }

    reset() {
        this.Progress.reset();
        return this;
    }

    back() {
        this.Progress.current.remove(); // Make sure previous is in the loop
        this.Progress.previous.remove(); // Make sure we can come back to this step after previous
        this.Progress.update();
    }

    next() {
        this.Progress.complete();
    }

    get post()  {
        return {
            designId:           this.Progress.getValue('create', 'id'),
            imageUuid:          this.Progress.getValue('upload', 'image'),
            cdnUrlModifiers:    this.Progress.getValue('edit', 'modifiers'),
            opacity:            this.Progress.getValue('color', 'opacity'),
            colorId:            this.Progress.getValue('color', 'color'),
            primaryHexColor:    this.Progress.getValue('color', 'primary')['hex'],
            secondaryHexColor:  this.Progress.getValue('color', 'secondary')['hex'],
            primaryCmykColor:   this.Progress.getValue('color', 'primary')['cmyk'],
            secondaryCmykColor: this.Progress.getValue('color', 'secondary')['cmyk'],
        }
    }

    async update() {
        this.Observer.notify();
        // Save data in Storage
        this.data = this.Progress.data;
    }

    get url() {
        let url = ['designs/individual'];
        if (this.btype === 'b2b') url.push(this.btype);
        return url.join('/');
    }

    saveOrUpdate() {
        const Progress = this.Progress;
        App.Interface.Api.post(this.url, {}, this.post, {async: false}, values => {
            Progress.get('create').save(values);
            Progress.update();
        }, () => {
            Progress.reset();
            this.start('upload');
        });
    }
}
